import React, {useCallback} from "react"
import {findDOMNode} from "react-dom"

import Popover from "../../../../../../gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../../../../../gd-components/gd-popover/popover-position"
import FieldSelectEntityField from "../../select-entity-field"
import convertFieldsStructureToConfig, {
    FieldSelectorConfig
} from "../../../../../../gd-modules/common/add-column-new/convert-fields-structure"
import {PopoverAttachmentType} from "../../../../../../gd-components/gd-popover/@const"
import PopoverAddColumn from "../../../../../../gd-modules/common/add-column-new/popover/popover"
import FieldProto from "../../../../../proto/field-proto"
import {GroupedData} from "../../../../../../data-structures/group"

type Props = {
    field           : FieldSelectEntityField
    model           : any
    parent          : any

    options         : any // field config oiptions

    offset?         : string

    onClickOutside  : func
    onSelect        : {(fieldId:ID | null, params?: any, selectedField?: FieldProto): void}
}

// const debug = "FieldSelectEntityField_SingleEntityPopover"
const debug = false

export default function FieldSelectEntityField_SingleEntityPopover(props:Props) {

    const value: any = props.field.getViewValue(props.model)
    const selectedFieldIds = props.field.fieldParams.selectedFieldIds ? props.field.fieldParams.selectedFieldIds : [value]

    const fieldsCollection: any = props.field.fieldsCollections[0]
    let fieldsStructure: GroupedData = []
    _.mapValues(props.field.fieldsStructures, (structure: GroupedData, key: string) => {
        fieldsStructure = structure
    })

    const config: FieldSelectorConfig = convertFieldsStructureToConfig(fieldsStructure)

    debug && console.log(debug, 'render', selectedFieldIds, value, props.field, config)

    const popoverPosition = new PopoverPosition({
        attachment      : props.options?.attachment,
        targetAttachment: props.options?.targetAttachment,
        offset          : props.offset,
        attachmentType  : PopoverAttachmentType.HORIZONTAL,
    })

    return (
        <Popover popoverClass     = "gd-popover-add-column-new"
                 position           = {popoverPosition}
                 onClickOutside     = {props.onClickOutside}
                 getTargetFunc      = {()=>findDOMNode(props.parent)}>
            <PopoverAddColumn config                 = {config}
                              fields                 = {fieldsCollection.models}
                              selectedFieldIds       = {selectedFieldIds}
                              columns                = {[{fieldId: value}]}
                              mandatoryColumnsIds    = {[]}
                              noValueOption          = {props.field.noValueOption ? {icon: props.field.noValueOptionIcon, label: props.field.noValueOptionLabel} : undefined}
                              isAddVisible           = {false}
                              hideEmptyCustomFields  = {true}
                              hidePopover            = {props.parent.hidePopover}
                              onToggleColumn         = {props.onSelect}
                              onNewCustomField       = {()=>{}}/>
        </Popover>
    )
}
